import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import { useUiStore } from '@/store/ui.store';

/**
 * Renders only the oldest queued snackbar so messages surface one at a
 * time in the order they were raised, instead of stacking multiple
 * `Snackbar`s (which MUI does not support out of the box).
 */
export function NotificationsSnackbar() {
  const snackbar = useUiStore((state) => state.snackbars[0]);
  const dismissSnackbar = useUiStore((state) => state.dismissSnackbar);

  if (!snackbar) return null;

  return (
    <Snackbar
      open
      autoHideDuration={5000}
      onClose={() => {
        dismissSnackbar(snackbar.id);
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert
        severity={snackbar.severity}
        variant="filled"
        onClose={() => {
          dismissSnackbar(snackbar.id);
        }}
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}
